import { render, staticRenderFns } from "./PayAfter.vue?vue&type=template&id=74b57bf2&scoped=true&"
import script from "./PayAfter.vue?vue&type=script&lang=js&"
export * from "./PayAfter.vue?vue&type=script&lang=js&"
import style0 from "./PayAfter.vue?vue&type=style&index=0&id=74b57bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b57bf2",
  null
  
)

export default component.exports